export default __webpack_public_path__ + "static/media/matt.e1b9b6d5.jpg";